import type { AdditionalCampaignData } from ".";

export default {
  campaignId: 12,
  title: "Regenerative Robots",
  posterImg: "/images/campaigns-page/reefgen/hero.png",
  impactTitle: "SEAGRASS SEEDS PLANTED",
  impactUnit: "seeds",
  ctaTitle: "SEEDS PLANTED BY UNDERWATER ROBOTS",
  impactLabel: "REGENERATIVE ROBOTS",
  dollarImpact: "Plants 7 seagrass seeds",
  bgColor: "bg-ocean",
  impactScore: 88,
  icon: "/images/emojis/herb.png",
  path: "/campaigns/reefgen",
  shortVideoId: "1084697861?h=9f484afb86",
  shortVideoIdMobile: "1084110717?h=d07d506c39",
  featuredReview: {
    name: "Dr Chiara Bertelli",
    photo: "/images/campaigns-page/reefgen/vettedby/chiara.jpeg",
    title:
      "Lecturer at Swansea University, An experienced marine ecologist with a PhD in seagrass ecology",
    quote:
      "Seagrass is essential to coastal ecosystems, and these robots are the future of restoration.",
  },
  ogImage: "/images/campaigns-page/reefgen/og-image.jpg",
} satisfies AdditionalCampaignData;
